import React, { useEffect, useRef } from 'react';
import '../assets/css/chat.css';

export default function Chat({ chatmsg, myview }) {
  const chatContainerRef = useRef(null);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [chatmsg]);

  return (
    <>
      <div className="chat-container" ref={chatContainerRef}>
        <div className="default"><p>Today</p></div>
        {chatmsg.map((message, index) => (
          <div key={index} className={message.from === "src" ? (myview === "Sender" ? "sender tri-right left-top" : "receiver tri-left right-top") : (myview === "Sender" ? "receiver tri-left right-top" : "sender tri-right left-top")}>
            <div className="talktext"> 
              <p>{message.message}<span>{message.time}</span></p>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}
